
<div class="shopRating">
  <views-rating-stars :rating="rating"></views-rating-stars>
  <div class="shopRating__label">口コミ件数：{{ reviewCount }}件</div>
</div>
